import { SectionHeader } from '../ui';
import { nowRows } from '../../data/log';

/** The homepage's one live surface: what is open right now, four lines. */
const NowStrip = () => {
  const rows = nowRows();
  if (!rows.length) return null;

  return (
    <section className="now-strip" aria-labelledby="now-heading">
      <div className="container">
        <SectionHeader
          id="now-heading"
          title="Right now"
          link="Full log →"
          linkTo="/life/log"
        />
        <div className="now-strip__list">
          {rows.map(({ category, item }) => (
            <div className="now-row" key={category.id}>
              <span className="now-row__label">{category.nowLabel}</span>
              <span className="now-row__value">{category.name(item)}</span>
              <span className="now-row__sub">{category.sub(item)}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default NowStrip;
